import { render, staticRenderFns } from "./myuser.vue?vue&type=template&id=37490573&scoped=true"
import script from "./myuser.vue?vue&type=script&lang=js"
export * from "./myuser.vue?vue&type=script&lang=js"
import style0 from "./myuser.vue?vue&type=style&index=0&id=37490573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37490573",
  null
  
)

export default component.exports